import type { FC } from "react";
import styled from "styled-components";
import { CircleSwitcherItem, Switcher } from "@similarweb/ui-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";

const ViewBySwitcherWrapper = styled(FlexRow)`
    align-items: center;
    justify-content: right;
    gap: 8px;
    white-space: nowrap;
`;

const StyledSwitcher = styled(Switcher)`
    margin: 0;
`;

export enum EViewBySwitcherItems {
    Channels,
    Domain,
}

export const VIEW_BY_TEXT = {
    [EViewBySwitcherItems.Channels]: "mmx.channelsoverview.channels.chart.viewby.switcher.channels",
    [EViewBySwitcherItems.Domain]: "mmx.channelsoverview.channels.chart.viewby.switcher.domain",
};

interface IViewBySwitcher {
    onViewChange: (selectedView: EViewBySwitcherItems) => void;
    selectedView: EViewBySwitcherItems;
}

const ViewBySwitcher: FC<IViewBySwitcher> = ({ onViewChange, selectedView }) => {
    const getSwitcherItems = () => {
        return Object.values(EViewBySwitcherItems)
            .filter((value) => typeof value === "number")
            .map((item) => <CircleSwitcherItem key={item}>{translate(VIEW_BY_TEXT[item])}</CircleSwitcherItem>);
    };

    const handleViewChange = (selectedViewBy: EViewBySwitcherItems) => {
        onViewChange(selectedViewBy);

        // update the URL with the selected view by
        const params = {
            channelsOverviewViewByType: EViewBySwitcherItems[selectedViewBy],
        };
        queueMicrotask(() => {
            proNavigator.applyUpdateParams(params, { reload: false });
        });

        allTrackers.dispatchTrackEvent("toggle", "click", `view by/` + EViewBySwitcherItems[selectedViewBy]);
    };

    return (
        <ViewBySwitcherWrapper data-automation="ViewBySwitcher">
            <StyledSwitcher
                selectedIndex={selectedView}
                customClass="CircleSwitcher"
                onItemClick={handleViewChange}
            >
                {getSwitcherItems()}
            </StyledSwitcher>
        </ViewBySwitcherWrapper>
    );
};

export default ViewBySwitcher;
